import { cn } from "@reactive-resume/utils";
import type { ReactNode } from "react";

import type { SettingsTabId } from "../types/settings";

type SettingsPanelProps = {
  tabId: SettingsTabId;
  activeTab: SettingsTabId;
  children: ReactNode;
  className?: string;
};

export const SettingsPanel = ({ tabId, activeTab, children, className }: SettingsPanelProps) => {
  if (tabId !== activeTab) {
    return null;
  }

  return (
    <section
      id={`settings-panel-${tabId}`}
      role="tabpanel"
      aria-labelledby={`settings-tab-${tabId}`}
      tabIndex={0}
      className={cn(
        "animate-in fade-in slide-in-from-bottom-2",
        "duration-300 focus-visible:outline-none",
        className,
      )}
    >
      {children}
    </section>
  );
};
